import { useCallback, useState } from 'react'

export const PasswordPinToggle = ({
  passwordpin,
}: {
  passwordpin: string | null
}) => {
  const [isPinVisible, isPinVisibleSet] = useState(false)

  const handleTogglePinVisible = useCallback(() => {
    isPinVisibleSet(!isPinVisible)
  }, [isPinVisible, isPinVisibleSet])

  if (!passwordpin) return <span>N/A</span>

  return (
    <span
      className="tracking-wider cursor-pointer"
      onClick={handleTogglePinVisible}
    >
      {isPinVisible ? passwordpin : '********'}
    </span>
  )
}
